module.exports = __webpack_public_path__ + "components/country-flag/static/cv-1621d5a1e85fc24b8948f8ac083a874f.svg";